import classNames from "classnames";
import { Builder } from "@finbox-in/lending-journey-renderer";
import { useLocation, useNavigate } from "react-router-dom";
import { MdAdd, MdDelete, MdOutlineArrowOutward } from "react-icons/md";
import { useRef, useState, useEffect } from "react";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import EditButton from "../../atomic/EditButton";
import EmailEditOTPModal from "../EmailEditOTPModal";
import DeleteButton from "../../atomic/DeleteButton";
import EditFieldsDataConfig from "../EditFieldsDataConfig";
import DialogOne from "../../../components/atomic/Dialog/DialogOne";
import ConfirmationDialog from "../ConfirmationModal/ConfirmationDialog";
import { CoApplicantEnum } from "../../../pages/CoApplicantTab/constant";
import LAPAddCoApplicant from "../../../pages/CoApplicantTab/AddCoApplicant/LapAddCoApplicant";
import OwnerShipBreakdownEditModal from "../OwnerShipBreakdownEditModal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { whiteLabelStyling } from "../../../shared/utils/constants";
import { scrollToSection } from "../../../pages/LoanApplicationForm/utils";
import { LoanApplicationService } from "../../../services/LoanApplication";
import { authService } from "../../../services/apis";
import { notify } from "../../../../../src/shared/context/AlertContext";
import { copyToClipboard } from "../../../../../src/shared/utils/DateUtil";
import UiConfigButton from "src/components/atomic/UiConfigButton/UiConfigButton";
import { forceDownloadLink } from "../../../shared/utils/Global";
import UiConfigCardSection from "../UiConfigCardSection";
import UIConfigList from "../UIConfigList";
import SectionActionButtons from "./SectionActionButtons";

import { IProps } from "./types";
import { getSelectedInfo, extractIdValueMap } from "./utils";
import {
  isFieldRequired,
  getValueOfKeyFromConfig,
  checkNestedSectionEditability,
  checkVisibility,
  checkNestedSectionDeletability,
  checkCoApplicantDeletablity,
  checkCoApplicantResumeActionVisiblity
} from "../../../services/ApiResponseMiddleware";
import ItemValue from "./ItemValue";

const SectionKeyValues = ({
  item,
  renderUIConfig,
  styles,
  isReferencesSection,
  isMFLLAP,
  handleFieldEdit,
  onEmailEdit,
  setShowJourneyBuilderForm
}: {
  item: any;
  renderUIConfig?: boolean;
  styles?: any;
  isReferencesSection?: boolean;
  isMFLLAP?: boolean;
  onEmailEdit?: (item: any) => void;
  handleFieldEdit?: (item: any) => void;
  setShowJourneyBuilderForm?: (show: { action: any; show: boolean }) => void;
}) => {
  const isMobile = window.innerWidth < 640;

  function handleBuilderActionClick(action: any) {
    if (action?.type === "ui_builder_action") {
      setShowJourneyBuilderForm?.({ action: action, show: true });
    }
  }

  return (
    <div
      className={classNames(
        "flex items-center border-gray-200",
        "sm:justify-between",
        !isMobile && "py-2 border-b",
        renderUIConfig && styles?.keyValuePair
      )}
    >
      {((isReferencesSection && isMFLLAP && item.id !== "id") ||
        !isReferencesSection) && (
        <>
          <div
            className={classNames(
              "w-4/12 text-xs font-medium text-gray-500",
              renderUIConfig && styles?.keys
            )}
          >
            {item?.name || item?.label}
          </div>

          <div
            className={classNames(
              "w-6/12 text-xs",
              renderUIConfig && styles?.values
            )}
          >
            <ItemValue item={item} />
          </div>

          <div className="w-2/12">
            {item?.buttonList?.["add"]?.visible?.isVisible && (
              <EditButton
                onClick={() => {
                  handleBuilderActionClick(item?.buttonList?.["add"]?.action);
                }}
              />
            )}

            {item?.buttonList?.edit?.visible?.isVisible && (
              <EditButton
                onClick={() => {
                  // if (onEmailEdit) onEmailEdit(item);
                  // else if (handleEditClick) handleEditClick(item);
                  if (handleFieldEdit) {
                    handleFieldEdit(item);
                  }
                }}
              />
            )}

            {item.id === "enach_url" && (
              <ClipboardDocumentIcon
                onClick={async () => {
                  try {
                    const value = item?.value || item?.Value;
                    if (value && typeof value === "string") {
                      const isSuccess = await copyToClipboard(value);
                      if (isSuccess) {
                        notify({
                          type: "success",
                          text: "Successfully Copied Link",
                          title: "Success"
                        });
                      } else {
                        notify({
                          type: "error",
                          text: "Failed to copy link",
                          title: "Error"
                        });
                      }
                    }
                  } catch (error) {
                    console.error("Failed to copy URL:", error);
                  }
                }}
                className="w-6 h-6 cursor-pointer hover:text-blue-600"
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

const SectionEditButton = ({
  item,
  editableFields,
  title,
  onClick
}: {
  item: any;
  editableFields: any;
  title: string;
  onClick?: (idValueMap: Record<string, string>) => void;
}) => {
  return (
    <span className="font-size-x-small pr-6">
      <EditButton
        styles={{ paddingX: "" }}
        onClick={() => {
          const editableFieldList = editableFields
            .filter((field: any) => field?.label === title)
            .flatMap((field: any) => field?.fieldList);

          const fields = Object.entries(editableFieldList).map(
            ([key, value]: any) => ({
              label: value?.label,
              value: value?.value,
              key: value?.id,
              isRequired: isFieldRequired(value) || false,
              id: value?.id,
              inputType: value?.type || "text",
              allowedValues: value?.allowedValue
            })
          );

          const idValueMap = extractIdValueMap(item);

          onClick?.(idValueMap);

          // setDefaultFieldValues(
          //   fields.reduce((acc: any, item: any) => {
          //     // TODO Need to ask if we need to add the key as the label or id when editing the fields
          //     acc[item.id] = item.value;

          //     return acc;
          //   }, {})
          // );
          // setShowEditApplicationFormModal(true);
          // setModalTitle("Edit fields of " + title);
          // setApplicationFormFields(fields);
        }}
      />
    </span>
  );
};

export default function DetailsAccordionSection({
  title,
  items = [],
  action,
  whiteLabelStyle: customStyle,
  renderUIConfig,
  isEditable = false,
  accordion = false,
  isFirstSection = false,
  styles,
  editableFields,
  pageName,
  isLenderPlatform,
  userID,
  loanApplicationID,
  sectionID,
  resourceName,
  token,
  notify,
  resourceNameSingleSubmit,
  selectedCoApplicantUserID,
  reload,
  sectionData,
  onDataRefresh,
  uiElements,
  editReference,
  activeTab,
  tabName,
  isMFLLAP,
  graphQLResponse,
  formButtons,
  loanDetails,
  sectionButtons,
  isEnach = false,
  showCustomButton = false,
  onCardActionClick,
  style: { titlePadding } = { titlePadding: true },
  isColending = false
}: IProps) {
  const sectionRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const [showEditApplicationFormModal, setShowEditApplicationFormModal] =
    useState<boolean>(false);
  const [applicationFormFields, setApplicationFormFields] = useState<
    Array<{ label: string; value: string; key: string }>
  >([]);
  const [defaultFieldValues, setDefaultFieldValues] = useState<
    Record<string, string | number>
  >({});

  const [isExpanded, setIsExpanded] = useState(false);
  const [modalTitle, setModalTitle] = useState<string>("");
  const [showJourneyForm, setShowJourneyForm] = useState(false);
  const [currentJson, setCurrentJson] = useState<any>({});
  const [isReferencesSection, setIsReferencesSection] = useState(false);
  const [showAddCoapplicantPopup, setShowAddCoapplicantPopup] = useState(false);
  const [deleteSectionConfirm, setDeleteSectionConfirm] = useState(false);
  const [sectionToDelete, setSectionToDelete] = useState<any>(null);
  const [sectionLabel, setSectionLabel] = useState<string>("");
  const [emailToEdit, setEmailToEdit] = useState<string>("");
  const [isEmailEditModalOpen, setIsEmailEditModalOpen] = useState(false);
  const [
    isOwnerShipBreakdownEditModalOpen,
    setIsOwnerShipBreakdownEditModalOpen
  ] = useState(false);
  const [ownerShipBreakdownToEdit, setOwnerShipBreakdownToEdit] =
    useState<any>(null);
  const [loadingButtons, setLoadingButtons] = useState<Record<string, boolean>>(
    {}
  );
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const { whiteLabelStyle: defaultStyle } = whiteLabelStyling();
  const whiteLabelStyle = customStyle || defaultStyle;

  const location = useLocation(),
    navigate = useNavigate();

  useEffect(() => {
    if (location && navigate) {
      const sectionTitle = decodeURIComponent(location?.hash?.replace("#", ""));
      if (sectionRefs.current[sectionTitle])
        scrollToSection(sectionRefs, sectionTitle, false);
    }
  }, [location, navigate]);

  useEffect(() => {
    if (isMFLLAP) {
      const isRefSection = sectionID === "references";
      setIsReferencesSection(isRefSection);
    }
  }, [isMFLLAP, sectionID]);

  useEffect(() => {
    if (isFirstSection) setIsExpanded(true);
    else setIsExpanded(!accordion);
  }, [accordion, isFirstSection]);

  const getUiConfig = async (resourceName?: string) => {
    const payload = {
      loanApplicationID: loanApplicationID,
      resourceName:
        resourceName === "umrn" ? "urm_number" : resourceName || tabName,
      sectionName: resourceName === "umrn" ? "nach_details" : sectionData?.id,
      service: isLenderPlatform ? "lender_dashboard" : "master_dashboard"
    };

    const response = (await LoanApplicationService.getFormUIConfig({
      token: token as string,
      payload: payload,
      isPlatformDashboard: !isLenderPlatform
    })) as any;

    if (response?.status) setCurrentJson(response?.data?.config || {});

    setShowJourneyForm(true);
  };

  const handlAddClick = () => setShowAddCoapplicantPopup(true);

  const handleEdit = (getUiConfig: any, items: any) => {
    setSelectedItem(items);
    const isCommunicationDetailsSectionInApplicationForm =
      (sectionID === "communication_details" &&
        tabName === "application_form_tab") ||
      (sectionID === "communication" && tabName === "application_form_tab");

    const isOwnerShipBreakdownSectionInCollateralDetails =
      sectionID === "Ownership_Breakdown_Details" &&
      tabName === "collateral_tab";

    if (
      isCommunicationDetailsSectionInApplicationForm &&
      items?.some((item: any) => item?.id === "email")
    ) {
      // Handle Communication Details section Edit in application form tab explicitly and not through UI Builder
      console.info("Handling email edit using custom modal");

      setIsEmailEditModalOpen(true);
      setModalTitle("Edit Email");
      setEmailToEdit(
        items.find((item: any) => item?.id === "email")?.value || ""
      );
    } else if (isOwnerShipBreakdownSectionInCollateralDetails) {
      // Handle Ownership Breakdown section Edit in collateral details tab explicitly and not through UI Builder
      console.info(
        "Handling ownership breakdown edit using custom modal",
        items
      );

      setIsOwnerShipBreakdownEditModalOpen(true);
      setModalTitle("Edit Ownership Breakdown");

      setOwnerShipBreakdownToEdit(items);
    } else {
      getUiConfig?.(items?.id);
    }
  };

  const deleteNestedSection = async (sectionToDelete: any) => {
    const response = await LoanApplicationService.upsertMetadata({
      token: token as string,
      payload: {
        userID: userID as string,
        identifier: "references",
        metadata: [sectionToDelete]
      },
      pageName: pageName as string,
      isLenderDashboard: isLenderPlatform!,
      isMFL_LAP: isMFLLAP!
    });

    if (response?.status) {
      notify({
        title: "Success",
        text: "Reference deleted successfully",
        type: "success"
      });

      reload(userID as string);
      setDeleteSectionConfirm(false);
      setSectionToDelete(null);
    } else {
      notify({
        title: "Error",
        text:
          (response?.data as any)?.msg ||
          response?.error ||
          "Something went wrong",
        type: "error"
      });
    }
  };

  const resumeCoApplicantJourney = async (nestedfieldList: any) => {
    const userInfo = nestedfieldList?.find((item) => item.id == "userID");

    const response: any = await LoanApplicationService.generateJourneyWebLink({
      token: token,
      pageName: pageName,
      payload: {
        userID: userInfo?.value,
        redirectURL: window.location.href
      },
      isPlatformDashboard: true
    });

    if (response?.status) {
      window.location.href = response?.data?.url;
    } else {
      notify({
        type: "error",
        text: response?.data?.message || "Failed to generate journey link.",
        title: "Error"
      });
    }
  };

  const deleteCoApplicant = async (nestedfieldList: any) => {
    const userInfo = nestedfieldList?.find((item) => item.id == "userID");
    const parentInfo =
      graphQLResponse?.loanApplication?.multiUserLoanRelations?.find(
        (userLoanData) => {
          return userLoanData?.user?.userID === userInfo?.value;
        }
      );

    const paylaod = {
      token: token,
      pageName,
      payload: {
        parentUserID: parentInfo?.parentUserID,
        userID: userInfo?.value,
        isLenderDashboard: false
      }
    };
    const response = await LoanApplicationService.deleteCoApplicant(paylaod);
    if (response?.status) {
      notify({
        title: "Success",
        type: "success",
        text: "CoApplicant Deleted Successfully!!"
      });
    } else {
      notify({
        title: "Error",
        text: response.error
      });
    }
  };

  // Helper function to resolve path expressions from graphQLResponse
  const resolvePathExpression = (path: string, data: any): string | null => {
    if (!path || !path.startsWith(".")) {
      return path; // Not a path expression, return as-is
    }

    try {
      // Remove leading dot and split by dots
      const keys = path.substring(1).split(".");
      let result: any = data;

      // Traverse the path
      for (const key of keys) {
        if (result === null || result === undefined) {
          return null;
        }
        result = result[key];
      }

      return typeof result === "string" ? result : null;
    } catch (error) {
      console.error("Error resolving path expression:", path, error);
      return null;
    }
  };

  const handleButtonAction = async (
    buttonKey: string,
    url: string,
    buttonLabel?: string
  ) => {
    // Resolve path expression if URL starts with a dot
    let resolvedUrl = url;
    if (url?.startsWith(".") && graphQLResponse) {
      resolvedUrl = resolvePathExpression(url, graphQLResponse) || url;
    }

    if (!resolvedUrl) {
      notify({
        title: "Error",
        text: "Download URL is not available",
        type: "error"
      });
      return;
    }
    setLoadingButtons((prev) => ({ ...prev, [buttonKey]: true }));

    try {
      const urlParts = resolvedUrl.split("/");
      const urlFileName = urlParts[urlParts.length - 1];
      // Remove query parameters if any
      const cleanFileName = urlFileName?.split("?")[0];
      const fileName =
        cleanFileName && cleanFileName.endsWith(".pdf")
          ? cleanFileName
          : `${buttonLabel || "document"}.pdf`;

      await new Promise((resolve) => setTimeout(resolve, 300));

      await forceDownloadLink(resolvedUrl, fileName);

      notify({
        title: "Success",
        text: `${buttonLabel || "File"} downloaded successfully`,
        type: "success"
      });
    } catch (error: any) {
      console.error("Failed to download file:", error);
      notify({
        title: "Download Failed",
        text:
          error?.message ||
          "Failed to download the file. Please try again later.",
        type: "error"
      });
    } finally {
      setLoadingButtons((prev) => ({ ...prev, [buttonKey]: false }));
    }
  };

  if (!isEnach && !items?.length) return null;

  return (
    <div
      className={classNames(
        "w-full md:mt-3",
        accordion
          ? `border-b md:border md:border-gray-200 md:rounded-lg ${titlePadding ? "md:p-6" : "p-3"} md:mb-4 `
          : "mb-6"
      )}
    >
      <div
        className={classNames(
          "flex items-center justify-between",
          accordion ? "h-10 ml-2 cursor-pointer" : "mb-2"
        )}
        id={`${title}`}
        ref={(el) => (sectionRefs.current[`${title}`] = el)}
        tabIndex={-1}
      >
        {title && !isColending && (
          <div className="flex items-center gap-2 w-full">
            <h3
              className={classNames(
                `text-sm font-medium border-b-2 ${titlePadding ? "px-2" : "px-0"} pb-1 pt-1 whitespace-nowrap`,
                whiteLabelStyle?.theme?.color?.border || "border-indigo-500",
                renderUIConfig && styles?.heading
              )}
            >
              {title}
            </h3>

            {action && <div>{action}</div>}
          </div>
        )}

        {checkVisibility(
          formButtons?.[CoApplicantEnum.ADD_COAPPLICANT_BUTTON]
        ) && (
          <div
            className="border mr-4 rounded p-1 cursor-pointer"
            onClick={handlAddClick}
          >
            <MdAdd size={20} />
          </div>
        )}

        {Object.entries(sectionButtons ?? {}).map(
          ([key, config]: [string, any]) => {
            return (
              <div className="mt-4 mr-4" key={key}>
                <UiConfigButton
                  key={`${sectionID}-${key}`}
                  loanApplicationID={loanApplicationID!}
                  clientSideInput={{
                    loanApplicationID: loanApplicationID as string,
                    userID: userID as string,
                    token: token as string
                  }}
                  buttonConfig={{
                    key: key,
                    ...config
                  }}
                  sectionID={sectionID}
                  tabName={tabName}
                  isLenderDashboard={isLenderPlatform!}
                  onClickFinished={onDataRefresh}
                />
              </div>
            );
          }
        )}

        {isEditable && (
          <SectionEditButton
            item={items}
            title={title as string}
            editableFields={editableFields}
            onClick={() => handleEdit(getUiConfig, items)} //Need handleEdit here.
            setDefaultFieldValues={setDefaultFieldValues}
            setShowEditApplicationFormModal={setShowEditApplicationFormModal}
            setApplicationFormFields={setApplicationFormFields}
            setModalTitle={setModalTitle}
          />
        )}

        {accordion && (
          <div
            className="w-5" //flex items-center gap-2
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? (
              <ChevronUpIcon className="w-5 h-5" />
            ) : (
              <ChevronDownIcon className="w-5 h-5" />
            )}
          </div>
        )}
      </div>

      {(isExpanded || !accordion) && (
        <>
          {/* Section-level buttons */}
          {sectionData?.buttonList &&
            showCustomButton &&
            Object.keys(sectionData.buttonList).length > 0 && (
              <SectionActionButtons
                buttonList={sectionData.buttonList}
                loanApplicationID={loanApplicationID}
                userID={userID}
                token={token}
                tabName={tabName}
                sectionID={sectionID}
                isLenderPlatform={isLenderPlatform}
                graphQLResponse={graphQLResponse}
                onDataRefresh={onDataRefresh}
                pageName={pageName}
                notify={notify}
              />
            )}

          {sectionData?.itemType === "Card" ? (
            <UiConfigCardSection
              isColending={isColending}
              sectionData={sectionData}
              items={items}
              loanApplicationID={loanApplicationID}
              userID={userID}
              token={token}
              pageName={pageName}
              isLenderDashboard={isLenderPlatform}
              graphQLResponse={graphQLResponse}
              tabName={tabName}
              onDataRefresh={onDataRefresh}
              onCardActionClick={onCardActionClick}
              activeTab={activeTab}
              whiteLabelStyle={whiteLabelStyle}
            />
          ) : sectionData?.itemType === "List" ? (
            <UIConfigList
              sectionData={sectionData}
              items={items}
              loanApplicationID={loanApplicationID}
              userID={userID}
              token={token}
              pageName={pageName}
              isLenderDashboard={isLenderPlatform}
              tabName={tabName}
              onDataRefresh={onDataRefresh}
              activeTab={activeTab}
              whiteLabelStyle={whiteLabelStyle}
            />
          ) : (
            items?.map((item: any, itemIndex: number) =>
              item?.nestedfieldList?.length > 0 ? (
                <div
                  key={item?.id || item?.label || `item-${itemIndex}`}
                  className={classNames(
                    "flex flex-col w-full",
                    resourceName === "coapplicant_tab" ? "border rounded" : "",
                    accordion
                      ? `${itemIndex > 0 ? "mt-4" : "mt-2"} ml-2`
                      : "py-4"
                  )}
                >
                  <div className="flex items-center gap-2 self-end mt-2 mr-2">
                    {checkVisibility(item?.tag) && (
                      <div className="px-2 py-1 text-xs font-medium rounded-xl bg-green-100">
                        {item?.tag?.label}
                      </div>
                    )}

                    {checkVisibility(item.buttonList?.edit) && (
                      <div className="flex items-center gap-2 self-end mt-2 mr-2">
                        <EditButton
                          buttonText={item.buttonList?.edit?.label}
                          onClick={() => handleEdit(getUiConfig, item)}
                        />
                      </div>
                    )}

                    {checkCoApplicantDeletablity(item) && (
                      <MdDelete
                        size={20}
                        onClick={() => deleteCoApplicant(item?.nestedfieldList)}
                      />
                    )}

                    {checkCoApplicantResumeActionVisiblity(item) && (
                      <MdOutlineArrowOutward
                        onClick={() =>
                          resumeCoApplicantJourney(item?.nestedfieldList)
                        }
                      />
                    )}
                  </div>

                  <div className="flex w-full justify-between">
                    <div
                      className={`text-sm font-small ${titlePadding ? "ml-2 mr-2" : "ml-0 mr-0"}`}
                    >
                      {item?.label}
                    </div>

                    <div className="flex items-center">
                      {checkNestedSectionDeletability(item) && (
                        <DeleteButton
                          buttonText=""
                          styles={{ buttonColor: "gray" }}
                          onClick={() => {
                            setDeleteSectionConfirm(true);
                            setSectionLabel(item.label);

                            setSectionToDelete({
                              id: getValueOfKeyFromConfig(
                                item.nestedfieldList,
                                "id"
                              ),
                              name: getValueOfKeyFromConfig(
                                item.nestedfieldList,
                                "name"
                              ),
                              type: getValueOfKeyFromConfig(
                                item.nestedfieldList,
                                "typeOfReference"
                              ),
                              address: getValueOfKeyFromConfig(
                                item.nestedfieldList,
                                "address"
                              ),
                              email_id: getValueOfKeyFromConfig(
                                item.nestedfieldList,
                                "email_id"
                              ),
                              mobile_number: getValueOfKeyFromConfig(
                                item.nestedfieldList,
                                "mobile_number"
                              ),
                              status: "INACTIVE"
                            });
                          }}
                        />
                      )}

                      {item?.buttonList &&
                        Object.keys(item.buttonList).length > 0 && (
                          <SectionActionButtons
                            buttonList={item.buttonList}
                            loanApplicationID={loanApplicationID}
                            userID={userID}
                            token={token}
                            tabName={tabName}
                            sectionID={sectionID}
                            isLenderPlatform={isLenderPlatform}
                            graphQLResponse={graphQLResponse}
                            onDataRefresh={onDataRefresh}
                            pageName={pageName}
                            notify={notify}
                            nestedFieldList={item.nestedfieldList}
                            itemIndex={itemIndex}
                          />
                        )}

                      {/* Edit button for dynamic sections like  References */}
                      {checkNestedSectionEditability(item) && (
                        <SectionEditButton
                          item={item}
                          title={title as string}
                          editableFields={editableFields}
                          onClick={(values) => {
                            if (isMFLLAP && isReferencesSection) {
                              editReference?.(values);
                            } else {
                              getUiConfig?.();
                            }
                          }}
                          setDefaultFieldValues={setDefaultFieldValues}
                          setShowEditApplicationFormModal={
                            setShowEditApplicationFormModal
                          }
                          setApplicationFormFields={setApplicationFormFields}
                          setModalTitle={setModalTitle}
                        />
                      )}
                    </div>
                  </div>

                  {item?.nestedfieldList?.map(
                    (nestedItem: any, index: number) => (
                      <SectionKeyValues
                        key={
                          nestedItem?.id ||
                          `${item?.id || item?.label || itemIndex}-nested-${index}`
                        }
                        item={nestedItem}
                        renderUIConfig={renderUIConfig}
                        styles={styles}
                        isMFLLAP={isMFLLAP}
                        isReferencesSection={isReferencesSection}
                        handleFieldEdit={(item) => {
                          if (handleEdit) {
                            handleEdit(getUiConfig, item);
                          }
                        }}
                      />
                    )
                  )}
                </div>
              ) : (
                <div
                  className={classNames(
                    "flex flex-col w-full",
                    accordion ? "mt-2 ml-2" : "py-2"
                  )}
                  key={item?.id || item?.label || `item-${itemIndex}`}
                >
                  <SectionKeyValues
                    key={item?.id || item?.label || `item-${itemIndex}`}
                    item={item}
                    handleFieldEdit={() => handleEdit(getUiConfig, item)}
                    renderUIConfig={renderUIConfig}
                    styles={styles}
                    isMFLLAP={isMFLLAP}
                    setShowJourneyBuilderForm={async (action: any) => {
                      action = action?.action;

                      await getUiConfig(action?.params?.resourceName);
                      setShowJourneyForm(true);
                    }}
                    isReferencesSection={isReferencesSection}
                  />
                </div>
              )
            )
          )}
        </>
      )}

      <DialogOne
        title={`${modalTitle}`}
        styles={{
          panel: "max-w-lg",
          overflowY: false,
          childrenPadding: false
        }}
        open={showEditApplicationFormModal}
        setOpen={setShowEditApplicationFormModal}
      >
        <EditFieldsDataConfig
          fields={applicationFormFields}
          pageName={pageName ?? ""}
          token={token ?? ""}
          defaultFieldValues={defaultFieldValues}
          onClose={() => setShowEditApplicationFormModal(false)}
          isLenderPlatform={isLenderPlatform ?? false}
          userID={userID as string}
          loanApplicationID={loanApplicationID as string}
          sectionID={sectionID}
          resourceName={resourceName}
          notify={notify}
          selectedCoApplicantUserID={selectedCoApplicantUserID}
          resourceNameSingleSubmit={resourceNameSingleSubmit}
          reload={reload}
        />
      </DialogOne>

      <DialogOne
        open={showJourneyForm}
        setOpen={setShowJourneyForm}
        title={" Form"}
        styles={{
          panel: `p-2 !w-[480px] catdog ${window.innerWidth < 640 ? "h-[90vh] mb-10" : "h-[90vh]"} overflow-scroll`
        }}
      >
        {Object.keys(currentJson).length > 0 && (
          <Builder
            key={JSON.stringify(currentJson)}
            config={currentJson}
            navigate={() => {}}
            onSubmit={(data) => {
              if (data?.status === 200) {
                notify({
                  title: "Success",
                  text: "Form submitted successfully",
                  type: "success"
                });

                setShowJourneyForm(false);
                reload(userID as string);
              } else {
                notify({
                  title: "Error",
                  text:
                    data?.error?.message ||
                    data?.error ||
                    "Something Went Wrong",
                  type: "error"
                });
              }
            }}
            loading={false}
            context={{
              moduleName: "default",
              graphQLResponse: {
                ...graphQLResponse,
                selectedInfo: getSelectedInfo(selectedItem, graphQLResponse),
                applicantType:
                  selectedCoApplicantUserID === loanDetails?.userID
                    ? "primary"
                    : "co-applicant"
              },
              uiElements: uiElements
            }}
            apiBasePath={import.meta.env.REACT_APP_JOURNEY_RENDERER_URL}
            apiHeaders={{
              token: token as string,
              "Page-Header": pageName as string,
              authorization: `Bearer ${authService.getBearerToken()}`
            }}
            onDomClick={() => {}}
            isStyleEditor={false}
            reloadConfig={() => {}}
          />
        )}
      </DialogOne>

      <DialogOne
        open={showAddCoapplicantPopup}
        setOpen={setShowAddCoapplicantPopup}
      >
        <LAPAddCoApplicant
          token={token}
          loanID={loanApplicationID}
          isLenderDashboard={false}
        />
      </DialogOne>

      <ConfirmationDialog
        open={deleteSectionConfirm}
        onConfirm={() => deleteNestedSection(sectionToDelete)}
        setOpen={setDeleteSectionConfirm}
        confirmButtonText="Delete"
        description={`Are you sure you want to delete ${sectionLabel}?`}
      />

      <DialogOne
        title={`${modalTitle}`}
        styles={{
          panel: "max-w-lg",
          overflowY: false,
          childrenPadding: false
        }}
        open={isEmailEditModalOpen}
        setOpen={setIsEmailEditModalOpen}
      >
        <EmailEditOTPModal
          isLenderPlatform={isLenderPlatform ?? false}
          isOpen={isEmailEditModalOpen}
          onClose={() => setIsEmailEditModalOpen(false)}
          defaultValue={emailToEdit}
          selectedCoApplicantUserID={selectedCoApplicantUserID!}
          loanApplicationID={loanApplicationID as string}
          token={token as string}
          pageName={pageName as string}
          notify={notify}
          onSuccess={() => reload(userID as string)}
        />
      </DialogOne>

      <DialogOne
        open={isOwnerShipBreakdownEditModalOpen}
        setOpen={setIsOwnerShipBreakdownEditModalOpen}
        title={"OwnerShip Breakdown"}
        styles={{
          panel: "sm:!w-[480px] md:!w-[680px] lg:!w-[1050px] overflow-y-auto"
          // panelHeight: "h-[60vh]",
        }}
      >
        <OwnerShipBreakdownEditModal
          isPlatformDashboard={isLenderPlatform ?? false}
          onClose={() => setIsOwnerShipBreakdownEditModalOpen(false)}
          defaultValue={ownerShipBreakdownToEdit}
          loanDetails={loanDetails}
          loanApplicationID={loanApplicationID as string}
          userID={userID as string}
          token={token as string}
          pageName={pageName as string}
          notify={notify}
          isMFLLAP={isMFLLAP!}
        />
      </DialogOne>
    </div>
  );
}
